import React from 'react';
interface ScrollHintTableProps {
  children: React.ReactNode;
  minWidth?: string;
}
export function ScrollHintTable({
  children,
  minWidth = '560px'
}: ScrollHintTableProps) {
  return <div data-id="element-254" data-mp="1i7eim9hxx1bw">
      <p className="mb-2 text-center text-xs font-medium text-muted sm:hidden" data-id="element-255" data-mp="1i6wgiw8ljsw2">
        ← Desliza para ver la tabla completa →
      </p>
      <div className="scrollbar-hide overflow-x-auto rounded-2xl border border-brown/20 bg-white" data-id="element-256" data-mp="1mzfwu0yo524k">
        <div style={{
        minWidth
      }} data-id="element-257" data-mp="1rwoe7zbzt24r">{children}</div>
      </div>
    </div>;
}